module.exports = __webpack_public_path__ + "assets/images/project/icon/search_icon.svg?v=436764e0";